var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{class:{ 'menu-visible': _vm.isMenuVisible },attrs:{"id":"app"}},[_c('MainMenu'),_c('div',{staticClass:"page-container"},[_c('div',{staticClass:"content"},[_c('router-view')],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }